export const feedbackHandler = {
    pathPattern: '/brands/:brandId/feedback/:reviewId',
    toWeb: ({ brandId, reviewId }) => ({
        path: `/brands/${brandId}/feedback/${reviewId}`,
    }),
    meta: {
        title: 'Support request',
        description: 'Opens a customer support request in the operator dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'reviewId', in: 'path', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', reviewId: 'exampleReviewId' },
        },
    },
};
//# sourceMappingURL=feedback.js.map